(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class ZlnStickyHeaderV4 extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector(
        '.zln-header__menu-toggle'
      );

      this.drawer = this.querySelector(
        '.zln-header__drawer'
      );

      this.sectionWrapper =
        this.closest('.shopify-section') ||
        this.closest('.section-header');

      this.desktopMedia = window.matchMedia(
        '(min-width: 1280px)'
      );

      this.stickyEnabled =
        this.dataset.sticky === 'true';

      this.openLabel =
        this.dataset.openLabel || 'Open menu';

      this.closeLabel =
        this.dataset.closeLabel || 'Close menu';

      this.closeTimer = null;
      this.metricsTimer = null;
      this.stickyFrame = null;
      this.stickySentinel = null;
      this.headerHeight = 0;

      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onMediaChange =
        this.onMediaChange.bind(this);
      this.onDrawerClick =
        this.onDrawerClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.updateMetrics =
        this.updateMetrics.bind(this);
      this.updateStickyState =
        this.updateStickyState.bind(this);

      this.setupHeader();

      if (this.toggle && this.drawer) {
        this.toggle.addEventListener(
          'click',
          this.onToggle
        );

        this.drawer.addEventListener(
          'click',
          this.onDrawerClick
        );

        document.addEventListener(
          'keydown',
          this.onKeydown
        );

        this.desktopMedia.addEventListener(
          'change',
          this.onMediaChange
        );
      }

      window.addEventListener(
        'scroll',
        this.onScroll,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        this.onResize,
        { passive: true }
      );

      if ('ResizeObserver' in window) {
        this.headerResizeObserver =
          new ResizeObserver(() => {
            this.updateMetrics();
            this.updateStickyState();
          });

        this.headerResizeObserver.observe(this);
      }

      window.requestAnimationFrame(() => {
        this.updateMetrics();
        this.updateStickyState();
      });

      this.metricsTimer = window.setTimeout(() => {
        this.updateMetrics();
        this.updateStickyState();
      }, 150);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (!this.isConnected) {
            return;
          }

          this.updateMetrics();
          this.updateStickyState();
        });
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.closeTimer);
      window.clearTimeout(this.metricsTimer);

      if (this.stickyFrame) {
        window.cancelAnimationFrame(
          this.stickyFrame
        );
      }

      if (this.toggle) {
        this.toggle.removeEventListener(
          'click',
          this.onToggle
        );
      }

      if (this.drawer) {
        this.drawer.removeEventListener(
          'click',
          this.onDrawerClick
        );
      }

      document.removeEventListener(
        'keydown',
        this.onKeydown
      );

      if (this.desktopMedia) {
        this.desktopMedia.removeEventListener(
          'change',
          this.onMediaChange
        );
      }

      window.removeEventListener(
        'scroll',
        this.onScroll
      );

      window.removeEventListener(
        'resize',
        this.onResize
      );

      if (this.headerResizeObserver) {
        this.headerResizeObserver.disconnect();
      }

      document.documentElement.classList.remove(
        'zln-header-menu-open'
      );

      if (this.sectionWrapper) {
        this.sectionWrapper.classList.remove(
          'zln-header-section--managed',
          'zln-header-section--sticky',
          'zln-header-section--fixed',
          'zln-header-section--overlay-content'
        );

        this.sectionWrapper.style.removeProperty(
          '--zln-header-section-height'
        );
      }

      if (
        this.stickySentinel &&
        this.stickySentinel.parentNode
      ) {
        this.stickySentinel.parentNode.removeChild(
          this.stickySentinel
        );
      }
    }

    setupHeader() {
      if (!this.sectionWrapper) {
        return;
      }

      this.sectionWrapper.classList.add(
        'zln-header-section--managed',
        'zln-header-section--overlay-content'
      );

      if (!this.stickyEnabled) {
        return;
      }

      this.stickySentinel =
        document.createElement('span');

      this.stickySentinel.className =
        'zln-header-sticky-sentinel';

      this.stickySentinel.setAttribute(
        'aria-hidden',
        'true'
      );

      this.sectionWrapper.parentNode.insertBefore(
        this.stickySentinel,
        this.sectionWrapper
      );

      this.sectionWrapper.classList.add(
        'zln-header-section--sticky'
      );
    }

    updateMetrics() {
      if (
        !this.isConnected ||
        !this.sectionWrapper
      ) {
        return;
      }

      const height = Math.ceil(
        this.getBoundingClientRect().height
      );

      if (height <= 0) {
        return;
      }

      this.headerHeight = height;

      this.sectionWrapper.style.setProperty(
        '--zln-header-section-height',
        `${height}px`
      );

      document.documentElement.style.setProperty(
        '--zln-global-header-height',
        `${height}px`
      );

      document.documentElement.style.setProperty(
        '--zln-header-stack-height',
        `${height}px`
      );
    }

    updateStickyState() {
      if (
        !this.stickyEnabled ||
        !this.sectionWrapper ||
        !this.stickySentinel
      ) {
        return;
      }

      const sentinelTop =
        this.stickySentinel
          .getBoundingClientRect()
          .top;

      const shouldFix = sentinelTop <= 0;

      this.sectionWrapper.classList.toggle(
        'zln-header-section--fixed',
        shouldFix
      );

      document.documentElement.style.setProperty(
        '--zln-global-header-top',
        shouldFix ? '0px' : `${Math.max(0, Math.round(sentinelTop))}px`
      );

      document.documentElement.style.setProperty(
        '--zln-global-header-bottom',
        shouldFix
          ? `${this.headerHeight}px`
          : `${Math.max(0, Math.round(sentinelTop)) + this.headerHeight}px`
      );
    }

    onScroll() {
      if (this.stickyFrame) {
        return;
      }

      this.stickyFrame =
        window.requestAnimationFrame(() => {
          this.stickyFrame = null;
          this.updateStickyState();
        });
    }

    onResize() {
      this.updateMetrics();
      this.updateStickyState();
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    get focusableElements() {
      if (!this.drawer) {
        return [];
      }

      return Array.from(
        this.drawer.querySelectorAll(
          'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(
        (element) => element.offsetParent !== null
      );
    }

    open() {
      if (
        !this.toggle ||
        !this.drawer ||
        this.isOpen
      ) {
        return;
      }

      window.clearTimeout(this.closeTimer);

      this.drawer.hidden = false;
      this.previousFocus = document.activeElement;

      window.requestAnimationFrame(() => {
        this.classList.add('is-open');

        document.documentElement.classList.add(
          'zln-header-menu-open'
        );

        this.toggle.setAttribute(
          'aria-expanded',
          'true'
        );

        this.toggle.setAttribute(
          'aria-label',
          this.closeLabel
        );

        window.setTimeout(() => {
          const firstFocusable =
            this.focusableElements[0];

          if (firstFocusable) {
            firstFocusable.focus({
              preventScroll: true
            });
          }
        }, 40);
      });
    }

    close({ restoreFocus = false } = {}) {
      if (
        !this.toggle ||
        !this.drawer ||
        !this.isOpen
      ) {
        return;
      }

      this.classList.remove('is-open');

      document.documentElement.classList.remove(
        'zln-header-menu-open'
      );

      this.toggle.setAttribute(
        'aria-expanded',
        'false'
      );

      this.toggle.setAttribute(
        'aria-label',
        this.openLabel
      );

      window.clearTimeout(this.closeTimer);

      this.closeTimer = window.setTimeout(() => {
        if (!this.isOpen) {
          this.drawer.hidden = true;
        }
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300);

      if (
        restoreFocus &&
        this.previousFocus instanceof HTMLElement
      ) {
        this.previousFocus.focus({
          preventScroll: true
        });
      }
    }

    onToggle(event) {
      event.preventDefault();

      if (this.isOpen) {
        this.close({ restoreFocus: true });
      } else {
        this.open();
      }
    }

    onDrawerClick(event) {
      const link = event.target.closest('a[href]');

      if (link) {
        this.close();
      }
    }

    onMediaChange(event) {
      if (event.matches) {
        this.close();
      }

      this.onResize();
    }

    onKeydown(event) {
      if (!this.isOpen) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close({ restoreFocus: true });
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      const focusable = [
        this.toggle,
        ...this.focusableElements
      ].filter(Boolean);

      if (focusable.length === 0) {
        return;
      }

      const first = focusable[0];
      const last =
        focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (
    !customElements.get('zln-sticky-header-v4')
  ) {
    customElements.define(
      'zln-sticky-header-v4',
      ZlnStickyHeaderV4
    );
  }

  } catch(e) { console.error(e); }
})();
})();
